import {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {TRootState} from '../../store/store';
import Button from '../Button/Button';
import {detachIcon} from '../../assets';
import {DistributionClient} from '../../generated/mlmbox/client/distribution/distribution.client';
import {transport} from '../../utils/constants';
import {Empty} from '../../generated/google/protobuf/empty';
import {getToken} from '../../utils/helper';
import {useDispatch} from 'react-redux';
import {setDistribution} from '../../store/distribution/distribution.slice';
import {default as SwipeModal, default as SwipeModalPublicMethods} from 'react-swipe-modal';
import AddWallet from './AddWallet';
import './Web3.scss';
import {useTranslation} from 'react-i18next';
import {useSession, useSessions} from '@walletconnect/modal-sign-react';
import {useNavigate} from 'react-router';
import {useAppKit, useAppKitAccount, useAppKitProvider, useDisconnect} from '@reown/appkit/react';
import {modal} from '../../main';

const Web3 = () => {
    const wallet = useSelector((state: TRootState) => state.distribution.value?.web3Address);
    const distribClient = new DistributionClient(transport);

    const [addWallet, setAddwallet] = useState(false);

    const addWalletModal = useRef<SwipeModalPublicMethods>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {address} = useAppKitAccount();
    const {walletProvider} = useAppKitProvider('eip155');
    const {open} = useAppKit();
    const {disconnect} = useDisconnect();

    function unlinkWallet() {
        distribClient.web3AddressDetach(Empty, {meta: {authorization: getToken()}}).then(({status, response}) => {
            if (status.code === 'OK') {
                dispatch(setDistribution(response));
                address && disconnect();
            }
        });
    }

    useEffect(() => {
        if (wallet) setAddwallet(false);
    }, [wallet]);

    useEffect(() => {
        if (addWalletModal.current) {
            if (addWallet) {
                addWalletModal?.current?.show();
            } else {
                addWalletModal?.current?.close();
                setAddwallet(false);
            }
        }
    }, [addWalletModal, addWallet]);

    return (
        <div className="web3">
            <h2>{t('w')}</h2>

            <p
                className={wallet ? 'wal' : ''}
            >
                {wallet ? (
                    <>
                        <span>{wallet.slice(0, 6)}</span>
                        {wallet.slice(6, -6)}
                        <span>{wallet.slice(-6)}</span>
                    </>
                ) : (
                    t('n_w')
                )}
            </p>

            {wallet ? (
                <Button
                    title={t('d_w')}
                    icon={detachIcon}
                    disabled
                    onClick={unlinkWallet}
                />
            ) : (
                <Button
                    title={t('o_w')}
                    height="50px"
                    onClick={() => setAddwallet(true)}
                />
            )}

            <SwipeModal
                hideBar={true}
                onClose={() => {
                    setAddwallet(false);
                }}
                modalStyle={{
                    bottom: addWallet ? '20px' : 0,
                }}
                backdropOpacity={0.8}
                ref={addWalletModal}>
                <>
                    <div className="close-modal btn-modal">
                        <svg
                            onClick={() => {
                                if (addWalletModal.current) addWalletModal.current.close();
                                setAddwallet(false);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none">
                            <path
                                d="M1.17282 12C0.514893 12 0 11.4702 0 10.8115C0 10.4964 0.114414 10.1957 0.343257 9.98084L4.3051 5.99999L0.343257 2.0334C0.114414 1.8043 0 1.51789 0 1.20286C0 0.529821 0.514893 0.0286375 1.17282 0.0286375C1.50178 0.0286375 1.75923 0.143189 1.98807 0.357995L5.97852 4.3389L9.99761 0.343668C10.2407 0.100239 10.4982 0 10.8128 0C11.4707 0 12 0.515509 12 1.17422C12 1.50358 11.8998 1.76133 11.6423 2.01909L7.66626 5.99999L11.6281 9.96661C11.8713 10.1814 11.9856 10.482 11.9856 10.8115C11.9856 11.4702 11.4565 12 10.7842 12C10.4553 12 10.1549 11.8855 9.94034 11.6563L5.97852 7.67544L2.03097 11.6563C1.80214 11.8855 1.50178 12 1.17282 12Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <AddWallet/>
                </>
            </SwipeModal>
        </div>
    );
};

export default Web3;
